<ng-template [ngIf]="title">
  <div class="library-title">
    <div class="title-wrap" [class.mobile]="deviceService.isMobile()">
      <div class="left">
        <ng-template [ngIf]="title.title">
          <h2 class="title bold">
            <ng-template [ngIf]="title.title_link && !title.new_title_link">
              <a [routerLink]="title.title_link">
                <span *ngFor="let t of titleParts; let i = index; trackBy: trackByFn"><ng-template [ngIf]="i > 0">{{ ', ' }}</ng-template>
                  {{ t | customLocale }}</span>
              </a>
            </ng-template>
            <ng-template [ngIf]="title.new_title_link && !title.title_link">
              <a [routerLink]="generatedLink()" [queryParams]="{currency: generatedParams()}" class="title_link">
                <span *ngFor="let t of titleParts; let i = index; trackBy: trackByFn"><ng-template [ngIf]="i > 0">{{ ', ' }}</ng-template>
                  {{ t | customLocale }}</span>
                <app-icon class="title-icon" file="chevron" icon="right"></app-icon>
              </a>
            </ng-template>
            <ng-template [ngIf]="!title.title_link && !title.new_title_link">
              <span *ngFor="let t of titleParts; let i = index; trackBy: trackByFn"><ng-template [ngIf]="i > 0">{{ ', ' }}</ng-template>
                {{ t | customLocale }}</span>
            </ng-template>

            <ng-template [ngIf]="title.add_link">
            <span class="add-btn" (click)="followLink(title.add_link)">
              <app-icon class="add-button-icon" icon="add-btn-title"></app-icon>
            </span>
            </ng-template>
          </h2>
        </ng-template>
        <ng-content select="[left]"></ng-content>
      </div>
      <div class="right" *ngIf="title.see_all_link">
        <ng-content select="[right]"></ng-content>
        <ng-template [ngIf]="title.see_all_link">
          <a class="all normal"
             [class.bottom]="title.all_bottom"
             [routerLink]="title.see_all_link">
            {{ 'library.content-filter.see-all' | customLocale }}
          </a>
        </ng-template>
      </div>
    </div>
    <div class="side-content-wrap">
      <ng-content select="[side]"></ng-content>
    </div>
    <div class="side-content-wrap">
      <ng-content select="[side2]"></ng-content>
    </div>
  </div>
</ng-template>
